import {Component} from '@angular/core';

interface WhyChooseItem {
  title: string;
  description: string;
}

@Component({
  selector: 'app-why-choose-template',
  standalone: true,
  templateUrl: './why-choose-template.component.html'
})
export class WhyChooseTemplateComponent {
  readonly items: WhyChooseItem[] = [
    {
      title: 'Simule antes de investir',
      description: 'Estime custos de aquisição, tributos e cenários com parâmetros ajustáveis para analisar melhor cada imóvel.'
    },
    {
      title: 'Antecipe oportunidades',
      description: 'Receba alertas sobre leilões próximos e acompanhe etapas importantes sem perder prazos relevantes.'
    },
    {
      title: 'Decida com clareza',
      description: 'Transformamos dados complexos em ferramentas objetivas para ajudar você a avaliar custos, riscos e oportunidades.'
    }
  ];
}
